import { render, staticRenderFns } from "./WurldRadioButton.vue?vue&type=template&id=cbe1d10c&"
import script from "./WurldRadioButton.vue?vue&type=script&lang=js&"
export * from "./WurldRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WurldRadioButton.vue"
export default component.exports